class ReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    if (!this.track) return;
    this.prev = this.querySelector('[data-prev]');
    this.next = this.querySelector('[data-next]');
    this.dots = Array.from(this.querySelectorAll('[data-dot]'));

    if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
    if (this.next) this.next.addEventListener('click', () => this.step(1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    window.addEventListener('resize', () => this.update());
    this.update();
  }

  get cards() {
    return Array.from(this.track.querySelectorAll('[data-card]'));
  }

  step(dir) {
    const card = this.cards[0];
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const amount = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
    this.track.scrollBy({ left: dir * amount, behavior: 'smooth' });
  }

  goTo(index) {
    const card = this.cards[index];
    if (!card) return;
    const delta = card.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
    this.track.scrollBy({ left: delta, behavior: 'smooth' });
  }

  update() {
    const trackLeft = this.track.getBoundingClientRect().left;
    let active = 0;
    let min = Infinity;
    this.cards.forEach((card, i) => {
      const d = Math.abs(card.getBoundingClientRect().left - trackLeft);
      if (d < min) {
        min = d;
        active = i;
      }
    });
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));

    const atStart = this.track.scrollLeft <= 1;
    const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
    if (this.prev) this.prev.disabled = atStart;
    if (this.next) this.next.disabled = atEnd;
  }
}

customElements.define('reviews-carousel', ReviewsCarousel);
